import React from "react";
import styled from "@emotion/styled";
import Colors from "../../styles/Colors";
import {keyframes} from "@emotion/core";

interface Props {
    color?: string,
}

const Loader = (
    {
        color = Colors.darkGrey,
    }: Props
) => {
    return <Spinner
        className="fas fa-spinner"
        color={color}
    />
}

export default Loader

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  
  to {
    transform: rotate(360deg);
  }
`

const Spinner = styled.i`
  animation: ${spin} linear infinite;
  animation-duration: 1s;
  color: ${props => props.color}
`
